<div style="padding: 1cm;">
  <!-- Top Buttons -->
  <div style="display: flex; justify-content: flex-end; gap: 12px; margin-bottom: 20px;" class="noPrint">
    <button
      mat-raised-button
      color="primary"
      style="font-size: 14px; font-weight: 600;"
      printTitle="Label"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>
    <button mat-dialog-close class="btn noPrint" style="font-size: 14px; font-weight: 600;">
      Close
    </button>
  </div>

  <!-- Printable Section -->
  <div id="print-section" style="background-color: white; padding: 1cm; margin-left: 100px;width: 100%;">
    <!-- Header Section -->
    <div style="margin-bottom: 0px; font-weight: bold; font-size: 14px; color: black;">
      <span style="margin-right: 20px;">{{ today | date:'dd/MM/yyyy hh:mm:ss' }} वर्गणी - वर्गणी जमा असलेले</span>
      <span *ngIf="deliveryMode" style="margin-right: 20px;">वितरण - {{ deliveryMode }}</span>
      <span *ngIf="repNames" style="margin-right: 20px;">
        <div>प्रतिनिधी पासून - {{ firstRepName }}</div>
        <div>प्रतिनिधी पर्यंत - {{ lastRepName }}</div>
      </span>
      <span *ngIf="district" style="margin-right: 20px;">जिल्हा - {{ district[0] }}</span>
      <span *ngIf="taluka" style="margin-right: 20px;">तालुका - {{ taluka[0] }}</span>
    </div>

    <!-- Label Cards -->
    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
      <div
        *ngFor="let item of data1; let i = index"
        style="
          width: 22.5%;
          border: 1px solid black;
          padding: 10px;
          box-sizing: border-box;
          min-height: 135px;
          font-size: 13px;
          color: black;
          page-break-inside: avoid;
        ">

        <div *ngIf="iscustomer === 'yes'" style="font-weight: bold;">
           {{ item['month'] }}/{{ item['subno'] }} - {{ item['year'] }}
        </div>

        <div style="font-weight: bold;">
          {{ item["name"] }}
        </div>

        <div>{{ item["address"] }}</div>
        <div>{{ item["taluka"] }}</div>
        <div>
          {{ item["district"] }}
          <span *ngIf="item['pincode'] !== 0"> - {{ item["pincode"] }} {{ item["state"] }}</span>
        </div>
        <div>{{ item["mobileNumber"] }}</div>
      </div>
    </div>
  </div>
</div>
